import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home, Business, Download, NotFound } from "./components/Relaunch";
import Metadata from "./components/Metadata";
import VerifyEmail from "./pages/VerifyEmail";
import PlacePage from "./pages/PlacePage";
import AppPrivacy from "./pages/AppPrivacy";
import AppTerms from "./pages/AppTerms";
import SignupReferral from "./pages/SignupReferral";
import "./App.css";
import "./editorial.css";
const App = () => {
  return <Router>
      <Metadata /><Routes>
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/cafeterias" element={<Business />} />
        <Route path="/empresas" element={<Business company />} />
        <Route path="/place/:id" element={<PlacePage />} />
        <Route path="/app" element={<Download />} />
        <Route path="/app-privacy" element={<AppPrivacy />} />
        <Route path="/app-terms" element={<AppTerms />} />
        <Route path="/signup" element={<SignupReferral />} />
        <Route path="/" element={<Home />} />
      <Route path="*" element={<NotFound />} /></Routes>
    </Router>;
};
export default App;
